'use client';

import { useRef, type RefObject } from 'react';
import { Box } from '@mantine/core';
import { RootBox } from '@/shared/RootBox';
import { SectionTitle } from '@/shared/SectionTitle';
import Scheme from './fgm-schm.svg';
import {
    TransformWrapper,
    TransformComponent,
    useControls,
} from 'react-zoom-pan-pinch';
import { PlusCircle, MinusCircle, XCircle } from 'lucide-react';
import { SectionSubtitle } from '@/shared/SectionSubtitle';

type ControlsProps = {
    targetRef: RefObject<HTMLDivElement | null>;
};

const Controls = ({ targetRef }: ControlsProps) => {
    const { zoomIn, zoomOut, resetTransform, zoomToElement } = useControls();

    const flyToTarget = (targetId: string) => {
        const el =
            targetRef.current?.querySelector('[data-zoom-target="true"]') ??
            targetRef.current?.querySelector(`#${targetId}`);
        if (!el) return;
        zoomToElement(el as HTMLElement, undefined, 500, 'easeOut');
    };

    const data = {
        name: ['Data Ingestion', 'Processing & Enrichment', 'Knowledge Hub', 'Analysis Loop', 'Calculation', 'Insights Delivery'],
        tier: ['Tier 1', 'Tier 2', 'Tier 3', 'Tier 4', 'Tier 5', 'Tier 6']
    }

    return (
        <div className="tools flex xxs:max-md:flex-col gap-3 items-center justify-between mb-6 w-full">
            <div className="flex gap-3">
                <button
                    onClick={() => zoomIn()}
                    className="bg-white/70 border border-black/5 hover:bg-white px-3 py-2 rounded-xl flex gap-2 text-xs md:text-sm items-center shadow-sm transition-colors"
                >
                    <PlusCircle className="size-3 md:size-4" /> Zoom In
                </button>
                <button
                    onClick={() => zoomOut()}
                    className="bg-white/70 border border-black/5 hover:bg-white px-3 py-2 rounded-xl flex gap-2 text-xs md:text-sm items-center shadow-sm transition-colors"
                >
                    <MinusCircle className="size-3 md:size-4" /> Zoom Out
                </button>
                <button
                    onClick={() => resetTransform()}
                    className="bg-white/70 border border-black/5 hover:bg-white px-3 py-2 rounded-xl flex gap-2 text-xs md:text-sm items-center shadow-sm transition-colors"
                >
                    <XCircle className="size-3 md:size-4" /> Reset
                </button>
            </div>
            {/*  <button
                onClick={flyToTarget}
                className="bg-white/70 border border-black/5 hover:bg-white px-3 py-2 rounded-xl flex gap-2 text-sm items-center shadow-sm transition-colors"
            >
                Приблизить к зоне
            </button> */}
            <div className="flex gap-3">
                {
                    data.tier.map((tier, index) => (
                        <p key={index} onClick={() => flyToTarget(tier.toLowerCase().replace(' ', ''))} className='text-slate-500 underline text-xs cursor-pointer'>
                            {data.name[index]}
                        </p>
                    ))}
            </div>
        </div>
    );
};

type Props = {};

export const FlowSchemeStatic = (props: Props) => {
    const schemeContainerRef = useRef<HTMLDivElement | null>(null);

    return (
        <Box id="systematicinvestmentengine" className="w-full xxs:max-md:hidden">
            <RootBox>
                <SectionTitle title="Systematic Investment Engine" index={4} />
                <SectionSubtitle
                          subtitle="A detailed insight into each step of our selection process"
                          highlights={[
                            'comprehensive coverage',
                            'performance benchmarks',
                            'truly systematic investment strategy',
                          ]}
                        />
                <div className="w-full max-w-full mx-auto h-[640px] flex flex-col items-center justify-start gap-4 mt-12 mb-20 rounded-3xl border border-black/10 bg-white/50 px-5 py-6 shadow-[0_25px_70px_rgba(0,0,0,0.05)] ">
                    <TransformWrapper
                        initialScale={1}
                        initialPositionX={0}
                        initialPositionY={0}
                        minScale={0.1}
                        maxScale={8}
                      
                        doubleClick={{ disabled: true }}
                        wheel={{ step: 0.2 }}
                        panning={{ velocityDisabled: true }}
                        limitToBounds={false}
                    >
                        <>
                            <Controls targetRef={schemeContainerRef} />
                            <TransformComponent
                                wrapperClass="!w-full h-full pb-1"
                                contentClass="!w-full !h-auto"
                                contentStyle={{ width: '100%', height: 'auto' }}
                            >
                                <div ref={schemeContainerRef} className="w-full">
                                    <Scheme className="w-full h-auto" />
                                </div>
                                {/* <Image src={Schemets} /> */}
                            </TransformComponent>
                        </>
                    </TransformWrapper>
                </div>
            </RootBox>
        </Box>
    );
};
